<template>
  <div class="order-list">
    <div class="order-list-head">
      <i class="el-icon-arrow-left" @click="back()"></i>
      <h2>订单列表</h2>
      <i class="el-icon-opt"></i>
      <!-- <i class="el-icon-search"></i> -->
    </div>
    <div class="order-list-search">
      <h6>时间：</h6>
      <p>
        <el-date-picker v-model="beginTime" type="date" placeholder="开始日期" :editable="false"
        value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="small" @change="searchFn"></el-date-picker>
      </p>
      <span>至</span>
      <p>
        <el-date-picker v-model="endTime" type="date" placeholder="结束日期" :editable="false"
        value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="small" @change="searchFn"></el-date-picker>
      </p>
      <h5>
        <el-checkbox v-model="backOrder" @change="searchFn">反结账</el-checkbox>
      </h5>
    </div>

    <div class="order-list-wrap" @scroll="handlerScroll" v-loading="loading">
      <div class="order-list-item" v-for="(i, index) in list" :key="'list-' + index" @click="optFn(0, i)">
        <div class="order-list-item-head">
          <div class="order-list-item-head-info">
            <h6>订单号：{{i.orderCode || '--'}}</h6>
            <h5>{{i.checkoutTime || '--'}}</h5>
          </div>
          <div class="order-list-item-head-price">
            <h6>￥{{i.realitymoney}}</h6>
            <p>台牌号：{{i.tableName || '--'}}</p>
          </div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="order-list-note" v-if="bottomMsg">{{bottomNote}}</div>
    </div>

    <div class="window-wrap" v-if="optShow">
      <div class="order-list-head">
        <i class="el-icon-arrow-left" @click="optShow=false"></i>
        <h2>订单详情</h2>
        <i class="el-icon-opt" @click="optFn(1)" v-if="!backOrder">反结账</i>
        <i class="el-icon-opt" @click="optFn(3)" v-else>再来一单</i>
      </div>
      <div class="window-wrap-content">
        <div class="order-list-item-info">
          <h6>订单号：</h6>
          <p>{{optInfo.orderCode || '--'}}</p>
        </div>
        <div class="order-list-item-info">
          <h6>结账时间：</h6>
          <p>{{optInfo.checkoutTime || '--'}}</p>
        </div>
        <div class="order-list-item-info">
          <h6>桌台牌号：</h6>
          <p>{{optInfo.tableName || '--'}}</p>
        </div>
        <div class="order-list-item-info">
          <h6>消费金额：</h6>
          <p>￥{{optInfo.shouldmoney}}</p>
        </div>
        <div class="order-list-item-info">
          <h6>优惠金额：</h6>
          <p>￥{{optInfo.discountAmount}}</p>
        </div>
        <div class="order-list-item-info">
          <h6>实收金额：</h6>
          <p>￥{{optInfo.realitymoney}}</p>
        </div>
        <!-- <div class="order-list-item-info">
          <h6>反结账状态：</h6>
          <p :style="'color:' + optInfo.backOrderColor">{{optInfo.backOrderMsg}}</p>
        </div> -->
        <div class="pay-name ">支付方式：</div>
        <div class="pay-list">
          <div class="order-list-item-info" v-for="(e, _index) in optInfo['paymentRecordEntities']" :key="'pay-' + _index">
            <h6>{{e.paymentName}}</h6>
            <p>￥{{e.paymentAmount}}</p>
          </div>
        </div>

        <div class="content_note">菜品详情：</div>
        <div class="content_item">
          <div class="content_tab" v-for="(i, index) in detailList" :key="'list-' + index">
            <div class="list_img">
              <viewer :images="[{ url: imguri + '/foodimage/png/' + i.foodimage, title: i.remark }]">
                <img :src="imguri + '/foodimage/png/' + (i.foodimage || 'LOGO.jpg')" alt="图片"/>
              </viewer>
            </div>
            <div class="list_info">
              <div class="clearFix">
                <em>
                  {{i.foodName}}
                  <span style="color: red" v-if="i.givefoodnumber>0">[赠{{i.givefoodnumber}}]</span>
                  <span style="color: red" v-if="i.returnfoodnumber>0">[退{{i.returnfoodnumber}}]</span>
                </em>
                <span style="margin-left: 10px;">￥{{i.price}} / x{{i.qty}}&nbsp;{{i.unit}}</span>
              </div>
              <p style="color:#ccc" v-if="i.remark && i.remark.length != 0">
                ( <span v-for="(j, index2) in i.remark">
                  {{j.name}}{{j.price > 0 ? ':￥' + j.price : ''}}
                  {{index2 < i.remark.length - 1 ? ',' : ''}}
                </span> )
              </p>
              <p style="color:#ccc" v-else-if="i.setMealItems && i.setMealItems.length != 0">
                ( <span v-for="(j, index2) in i.setMealItems">
                  {{j.foodName}}{{j.price > 0 ? ':￥' + j.price : ''}}
                  {{index2 < i.setMealItems.length - 1 ? ',' : ''}}
                </span> )
              </p>
            </div>
            <h4 class="list_money">￥{{i.amount}}</h4>
          </div>
        </div>
      </div>
    </div>

    <div class="checkout-window" v-if="checkoutShow" @click="checkoutShow=false">
      <div class="checkout-wrap" @click.stop>
        <h3>反结账</h3>
        <div class="checkout-wrap-content">
          <div class="checkout-wrap-item">
            <h6>理由：</h6>
            <p>
              <el-select v-model="checkoutObj" placeholder="请选择">
                <el-option label="无理由" :value="0"></el-option>
                <el-option label="更换支付方式" :value="1"></el-option>
                <el-option label="临时加菜" :value="2"></el-option>
                <el-option label="临时退菜" :value="3"></el-option>
                <el-option label="自定义理由" :value="4"></el-option>
              </el-select>
            </p>
          </div>
          <div class="checkout-wrap-item" v-if="checkoutObj == 4">
            <p>
              <el-input v-model="checkoutVal" placeholder="请输入反结账理由"></el-input>
            </p>
          </div>
        </div>
        <div class="checkout-wrap-btn">
          <h5 @click="optFn(2)">确认</h5>
        </div>
      </div>
    </div>

    <!-- 设置并台拆台的桌台弹窗 -->
    <div class="opt_PopUps" v-if="optTab" @click="optTab=false">
      <div class="opt_tab" @click.stop>
        <div class="tab_header">
          <h3>选择桌台</h3>
          <div @click="optTab=false">
            <img src="../../static/images/close_icon.png" alt="" />
          </div>
        </div>
        <div class="tab_content">
          <ul class="content_title">
            <li v-for="(i, index) in optInfo" @click="switchTab(index)" :class="{select:index == tabIndex}"
              v-if="i.shopTableList.length>0">{{i.name}}</li>
          </ul>
          <ul class="content_list">
            <li v-for="(i, index) in optInfoTab" @click="selectTab(i)" :class="{select:i.isSelect == true}">{{i.title}}</li>
          </ul>
          <div class="tab_opt">
            <el-button type="primary" @click="saveFn">确认</el-button>
            <el-button type="primary" @click="optTab=false">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  import { interfaceFn, timeFn } from '@/assets/util.js';
  export default {
    data () {
      return {
        msg: "",
        beginTime: timeFn('yyyy-MM-dd'),
        endTime: timeFn('yyyy-MM-dd'),
        backOrder: false,
        page: 1,
        limit: 20,
        list: [],
        total: 0,
        loading: false,
        bottomMsg: false,
        bottomNote: "",
        imguri: interfaceFn(1),
        optShow: false,
        detailList: [],
        optInfo: {
          paymentRecordEntities: []
        },
        checkoutShow: false,
        checkoutObj: 0,
        checkoutVal: "",
        selectInfo: {},
        optTab: false,
        optInfo: [],
        optInfoTab: [],
        tabIndex: 0
      }
    },
    created () {
      this.init();
    },

    methods: {
      init () {
        this.getListFn()
      },
      back () {
        this.$router.back();
      },

      searchFn () {
        this.list = [];
        this.page = 1;
        this.limit = 20;
        this.getListFn();
      },

      getListFn () {
        this.loading = true;
        this.$http.get(interfaceFn() + '/orderMessage/findOrdersAndPayment?merchantId='
        + localStorage.getItem('merchantId') + "&shopId=" + localStorage.getItem('shopId')
        + "&page=" + this.page + "&limit=" + this.limit + (this.backOrder ? '&backOrder=1' : '')
        + "&beginTime=" + this.beginTime + "&endTime=" + this.endTime).then((res) => {
          this.loading = false;

          if (res.data.returnCode == "ok") {
            let data = res.data;
            this.total = data.total;
            this.list = this.list.concat(data.result);

            if (data.total == 0 || data.result.length == 0) {
              this.bottomNote = '暂无相关信息';
              this.bottomMsg = true;
            } else {
              this.bottomNote = '已加载完全部信息';
            }
          }
        }).catch(() => {
          this.loading = false;
        })
      },

      // 反结账操作
      optFn (n, i) {
        if (n == 0) {
          this.optInfo = i;
          // 获取菜品
          this.$http.get(interfaceFn() + '/orderMessage/findOrderItems?shopId=' + localStorage.getItem('shopId')
          + '&orderCode=' + i.orderCode).then((res) => {
            if (res.data.returnCode == 'ok') {
              this.optShow = true;
              let result = res.data.result;
              result.filter(f => {
                if (f.remark) {
                  var remark = JSON.parse(f.remark);
                  var remarkList = [];
                  for (var i in remark) {
                    remarkList.push({
                      name: i,
                      price: remark[i]
                    })
                  }
                  f.remark = remarkList;
                }
              })
              this.detailList = result;
            } else {
              this.msgFn('warning', res.data.message, 1500);
            }
          })

        } else if (n == 1) {
          this.checkoutShow = true;
          this.checkoutObj = 0;
          this.checkoutVal = "";
        } else if (n == 2) {
          this.$confirm('确认对该订单进行反结账操作？', '反结账提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let reason = "";
            if (this.checkoutObj == 0) {
              reason = '无理由';
            } else if (this.checkoutObj == 1) {
              reason = '更换支付方式';
            } else if (this.checkoutObj == 2) {
              reason = '临时加菜';
            } else if (this.checkoutObj == 3) {
              reason = '临时退菜';
            } else if (this.checkoutObj == 4) {
              reason = this.checkoutVal;
            }

            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.$http.post(interfaceFn() + '/orderMessage/ordersReverseCheckout',
            qs.stringify({
              userId: userInfo.id,
              orderId: this.optInfo.id,
              reason: reason,
              orderCode: this.optInfo.orderCode
            }), {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }).then((res) => {
              if (res.data.returnCode == 'ok') {
                this.msgFn('success', '操作已提交', 1500);
                // this.optShow = false;
                this.checkoutShow = false;
                setTimeout(() => {
                  this.checkoutStatusFn();
                }, 1500)
                // this.searchFn();
              } else {
                this.msgFn('warning', res.data.message, 1500);
              }
            })
          }).catch(() => {});
        } else if (n == 3) {
          this.optTab = true;
          this.tabIndex = 0;
          this.optInfo = JSON.parse(JSON.stringify(this.$store.state.tabList));
          this.optInfoTab = this.optInfo[0].shopTableList;
        }
      },
      checkoutStatusFn () {
        this.$http.get(interfaceFn() + '/orderMessage/reverseCheckoutStatus?orderId=' + this.optInfo.id
        + '&orderCode=' + this.optInfo.orderCode).then((res) => {
          if (res.data.returnCode == 'ok') {
            let result = res.data.result;
            let msg = '', color = "";
            // 0：正在发送到前台处理,1:已经到前台处理，2：反结账成功，3：反结账失败
            if (result == 0) {
              msg = '正在发送到前台处理';
              color = 'blue';
            } else if (result == 1) {
              msg = '已经到前台处理';
              color = 'orange';
            } else if (result == 2) {
              msg = '反结账成功';
              color = 'green';
            } else if (result == 3) {
              msg = '反结账失败';
              color = 'red';
            } else {
              return;
            }

            this.$confirm(msg, '反结账提示', {
              confirmButtonText: '确定',
              cancelButtonText: '关闭',
              type: 'warning'
            }).then(() => {}).catch(() => {});
            this.optInfo.backOrderStatus = result;
            this.optInfo.backOrderMsg = msg;
            this.optInfo.backOrderColor = color;
          } else {
            this.msgFn('warning', res.data.message, 1500);
          }
        }).catch(() => {
          this.optInfo.backOrderStatus = '';
          this.optInfo.backOrderMsg = '--';
          this.optInfo.backOrderColor = '';
        })
      },

      //操作切换tab页
      switchTab(index) {
        this.optInfoTab = this.optInfo[index].shopTableList;
        this.tabIndex = index;
      },

      //选中桌台
      selectTab(info) {
        this.optInfoTab.filter(f => f.isSelect = false);
        info.isSelect = !info.isSelect;
        this.curTabName = info.title;
        this.selectInfo = info;
        this.$forceUpdate();
      },

      saveFn () {
        let list = [];
        this.detailList.filter(f => {
          if (f.returnfoodnumber == 0) {
            list.push(JSON.parse(JSON.stringify({
              allMoney: f.amount,
              canteenstatus: f.canteenstatus,
              discount: 0,
              foodId: f.foodId,
              foodName: f.foodName,
              foodimage: f.picture,
              givefoodnumber: 0,
              isDecimal: f.isDecimal,
              isweigh: f.isweigh,
              originalPrice: f.originalPrice,
              price: f.price,
              qty: f.qty,
              remark: f.remark,
              returnfoodnumber: 0,
              setMealItems: f.setMealItems,
              startOrderQty: f.startOrderQty,
              unit: f.unit,
              urgeNum: f.urgeNum
            })))
          }
        })
        localStorage.setItem('newCartList', JSON.stringify(list));
        localStorage.setItem('curClickInfo', JSON.stringify(this.selectInfo));
        this.$router.push({path: "/room"})
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.$http.post(interfaceFn() + '/shopTable/tableOperate',
        qs.stringify({
          shopId: localStorage.getItem('shopId'),
          tableId: this.selectInfo.id,
          userId: userInfo.id,
          operate: 1,
          remark: '',
          mealsNumber: 1
        }), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }).then((res) => {})
      },

      /* 触底操作 */
      handlerScroll (e) {
        // 判断是否到底了
        if (e.srcElement.scrollTop + e.srcElement.offsetHeight > e.srcElement.scrollHeight - 1) {
          this.page += 1;
          if (this.total > this.page * this.limit - this.limit) {
            this.getListFn();
            this.bottomMsg = false;
          } else {
            this.bottomMsg = true;
          }
        }
      },

      // 提示
      msgFn(type, msg, time) {
        this.$Message({
          duration: time,
          message: msg,
          center: true,
          type: type
        });
      }
    }
  }
</script>

<style scoped>
  @import "../../static/css/orderList.css";
</style>



// WEBPACK FOOTER //
// src/components/OrderList.vue